import DashboardClient from './DashboardClient';
import HttpClient from '../../gateway/HttpClient';
import { notUndefined } from '../../util/Assert';
import HttpMethod from '../../constant/HttpMethod';
import { query } from '@trlogic/client-js';
import Query = query.Query;
import { Dashboard } from '../../domain/dashboard/DashboardDomains';
import { DashboardMethods } from '../../constant/MethodNames';
import { CustomFilter } from '../../domain/ui/FilterDomains';

class NestDashboardClient implements DashboardClient {
  private httpClient: HttpClient;

  constructor(httpclient: HttpClient) {
    notUndefined(httpclient, 'httpclient must not be undefined');
    this.httpClient = httpclient;
  }

  public async save(dashboard: Dashboard): Promise<string> {
    const dto: {
      dashboard: Dashboard;
    } = {
      dashboard,
    };
    return await this.httpClient.execute(HttpMethod.POST, `${DashboardMethods.SAVE}`, dto);
  }

  public async remove(id: string): Promise<any> {
    return await this.httpClient.execute(HttpMethod.DELETE, `${DashboardMethods.REMOVE}/${id}`);
  }

  public async getDashboard(id: string, filter?: any): Promise<any> {
    return await this.httpClient.execute(HttpMethod.POST, `${DashboardMethods.GET_DASHBOARD}/${id}`, filter);
  }

  public async count(query: Query): Promise<number> {
    return await this.httpClient.execute(HttpMethod.GET, `${DashboardMethods.COUNT}`, undefined, { query });
  }

  public async getRulePerformance(id: string, filter: CustomFilter) {
    return await this.httpClient.execute(HttpMethod.POST, `${DashboardMethods.GET_RULE_PERFORMANCE}/${id}`, filter);
  }
}

export default NestDashboardClient;
